// extracted by mini-css-extract-plugin
module.exports = {"Digit":"Digit_Digit__3F54T"};